export default __webpack_public_path__ + "static/media/dashboardbed.8bbae294.svg";